import { render, staticRenderFns } from "./EditorSideControlsDesktop.vue?vue&type=template&id=27a73903&scoped=true&"
import script from "./EditorSideControlsDesktop.vue?vue&type=script&lang=ts&"
export * from "./EditorSideControlsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./EditorSideControlsDesktop.vue?vue&type=style&index=0&id=27a73903&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a73903",
  null
  
)

export default component.exports